"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;
/*eslint no-console:0*/
function log() {
  if (undefined) console.log(...arguments);
}